import {
  Component,
  SimpleChanges,
  ViewChild,
  OnChanges,
  ChangeDetectorRef,
  AfterViewInit
} from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TrainingsTrackerModel } from '../trainings_tracker_grid';
import { TrainingsTrackerService } from '../trainings_tracker.service';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog'
import { Router } from "@angular/router";
import { AddTrainingsModel } from 'src/app/Models/addTrainingsModel';
import { ToastrService } from 'ngx-toastr';
import { CompetenciesService } from 'src/app/views/competencies/competencies.service';
import { OthersService } from 'src/app/views/competencies/others/othersDataService';
import { FormGroup } from '@angular/forms';
import { CompetencyDropdownModel } from 'src/app/Models/competencyDropdownModel';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { TrainingActionsComponent } from '../training-actions/training-actions.component';
import { ExcelService } from 'src/app/services/excel-service.service';


/**
 * @title Data table with sorting, pagination, and filtering.
 */
@Component({
  selector: "trainings-grid",
  templateUrl: "./trainings_tracker_grid.component.html",
  styleUrls: ["./trainings_tracker_grid.component.css"],
})

export class TrainingsTrackerGridComponent implements OnChanges, AfterViewInit {
  AddTrainingsForm: FormGroup;
  public saveTrainingsDetails: AddTrainingsModel = new AddTrainingsModel();
  public selectedServicelineValues: CompetencyDropdownModel[];

  displayedColumns: string[] = [
    'statusIcon',
    'competencyName',
    'trainingName',
    'startDate',
    'endDate', 
    // 'plannedResourcesCount',
    'status',
    'actions'
  ];
  // displayedColumns: string[] = ['competencyName', 'trainingName', 'trainingMode', 'locationName', 'trainerName',
  //   'startDate', 'endDate', 'plannedResourcesCount', 'prerequisiteTools', 'status', 'actions'];
  dataSource: MatTableDataSource<TrainingsTrackerModel> = new MatTableDataSource<any>([]);
  // Set the initial active page
  pageSize = 8;
  totalItems: number;
  currentPage = 1;
  compId: number;
  subCompId: number;
  users: TrainingsTrackerModel[] = [];
  filteredNames: TrainingsTrackerModel[];
  masterData: TrainingsTrackerModel[];
  public prepopulatedDataObject: AddTrainingsModel = new AddTrainingsModel;
  trainingTypeId: number;
  trainingTypeName: string;
  subCompetencyName: string;
  competencyname: string;
  name: any
  id: any
  searchData: TrainingsTrackerModel[];
  plpaceholderText: string;
  selectedTabIndex: number = 0;
  empSize = 3000;
  from = 0;
  size = 10;
  @ViewChild(MatTabGroup) matTab: MatTabGroup;
  trainingChartData = {
    labels: ['Completed', 'Delayed', 'In progress', 'New'],
    datasets: [{
      data: [35, 25, 30, 10],
    }]
  };
  topTrainings = [];

  totalTrainingData = [];

  totalRecords = 0;

  employeeTrainingStatus = [];

  serviceAreaList:any = [];

  constructor(private _service: TrainingsTrackerService,
    private toastr: ToastrService,
    public dialog: MatDialog,
    private competencyService: CompetenciesService,
    public othersService: OthersService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private excel: ExcelService,
  ) { }
  ngAfterViewInit(): void {

  }
  ngOnChanges(changes: SimpleChanges): void {
    
  }
  searchText: '';
  subCompetencyChartData = [];

  @ViewChild(MatSort) sort: MatSort;
  ngOnInit() {
    this.othersService.selectedCompetencyID$.subscribe(res => {
      this.compId = res;
      if (this.compId == null || this.compId == 0) {
        this.compId = Number(sessionStorage.getItem("compId"))
      }

      this.othersService.id$.subscribe(res => {
        this.subCompId = res;
        if (this.subCompId == null || this.subCompId == 0) {
          this.subCompId = Number(sessionStorage.getItem("SubcompId"))
        }
      });
    });
    this.competencyService.competencyName$.subscribe(x => {
      this.competencyname = x
      if (this.competencyname == null || this.competencyname == "") {
        this.competencyname = sessionStorage.getItem("compTitle")
      }
    });
    this.othersService.name$.subscribe(name => {
      this.subCompetencyName = name;
      if (this.subCompetencyName == null || this.subCompetencyName == "") {
        this.subCompetencyName = sessionStorage.getItem("SubcompTitle")
      }
    });
    this.fetchData();
    this.renderTable();
  }

  getResourceCount(resourcesPlanned) {
    return typeof resourcesPlanned === 'string' ? resourcesPlanned.split(', ').length : 0;
  }

  createTraining(trainingTypeName, trainingTypeId) {
    const sendData = {
      value: this.trainingTypeId,
      name: this.trainingTypeName,
    }
    this._service.setFormData(null);
    this.othersService.updatetriningtypeId(sendData);
    this.subCompetencyName = this.subCompetencyName.replace(/\//g, '');
    this.subCompetencyName = this.subCompetencyName.split(' ').join('');
    this.router.navigate([`Home/CMF Portal/${this.competencyname}/${this.subCompetencyName}/Trainings/${sendData.name}/addTrainings`])
  }

  onPageButtonClick(page: number): void {
    if (page !== this.currentPage) {
      this.currentPage = page;
      this.fetchData();
    }
  }

  onPreviousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.fetchData();
    }
  }

  onNextPage(): void {
    const totalPages = this.getTotalPages();
    if (this.currentPage < totalPages) {
      this.currentPage++;
      this.fetchData();
    }
  }

  getTotalPages(): number {
    return Math.ceil(this.totalItems / this.pageSize);
  }



  getPageNumbers(): number[] {
    const totalPages = this.getTotalPages();
    const visiblePages = Math.min(totalPages, 4); // Adjust the number of visible page buttons as needed
    const currentPageIndex = this.currentPage - 1;
    let startPageIndex: number;
    let endPageIndex: number;
    if (totalPages <= visiblePages) {
      startPageIndex = 0;
      endPageIndex = totalPages - 1;
    } else {
      const maxPagesBeforeCurrentPage = Math.floor(visiblePages / 2);
      const maxPagesAfterCurrentPage = Math.ceil(visiblePages / 2) - 1;
      if (currentPageIndex <= maxPagesBeforeCurrentPage) {
        // Current page is near the start
        startPageIndex = 0;
        endPageIndex = visiblePages - 1;
      } else if (currentPageIndex >= totalPages - 1 - maxPagesAfterCurrentPage) {
        // Current page is near the end
        startPageIndex = totalPages - visiblePages;
        endPageIndex = totalPages - 1;
      } else {
        // Current page is in the middle
        startPageIndex = currentPageIndex - maxPagesBeforeCurrentPage;
        endPageIndex = currentPageIndex + maxPagesAfterCurrentPage;
      }
    }

    return Array.from({ length: endPageIndex - startPageIndex + 1 }, (_, i) => startPageIndex + i + 1);
  }

  fetchData() {
    this.othersService.triningtypeid$.subscribe(value => {
      this.trainingTypeId = value.value;
      this.trainingTypeName = value.name;
      if (this.trainingTypeId == null || this.trainingTypeId == 0) {
        this.trainingTypeId = Number(sessionStorage.getItem("TrainingtypeId"))
      }
      if (this.trainingTypeName == null || this.trainingTypeName == "") {
        this.trainingTypeName = sessionStorage.getItem("TrainingTypename")
      }
    });

    this.plpaceholderText = "Search For " + this.trainingTypeName + "..."
    const Params = {
      compId: Number(sessionStorage.getItem("compId")),
      serviceArea: sessionStorage.getItem("SubcompTitle")
    };

    this._service.getCMFTopTrainingsList(Params).subscribe((res) => {
      this.topTrainings = Array.isArray(res) ? res : [];
    });

    // this._service.getAllTrainingsDetails(this.compId, this.subCompId, this.trainingTypeId).subscribe(
    //   (results) => {
    //     this.users = results;
    //     this.filteredNames = results;

    //     for (let i of this.filteredNames) {
    //       if (i.status == 'NotStarted') {
    //         i.color = "#00BA34";
    //       }
    //       else if (i.status == 'InProgress') {
    //         i.color = "#FF9F2D";
    //       }
    //       else if (i.status == 'Completed') {
    //         i.color = "#183B8C";
    //       }
    //       else {
    //         i.color = "#E92C2C";
    //       }
    //     }
    //     this.masterData = this.filteredNames;
    //     const data = this.filteredNames.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
    //     this.dataSource = new MatTableDataSource(data);
    //     this.dataSource.sort = this.sort;
    //     this.totalItems = this.filteredNames.length;
    //     const startIndex = (this.currentPage - 1) * this.pageSize;

    //     const endIndex = Math.min(startIndex + this.pageSize, this.totalItems);
    //   });

    this._service.getCMFEmployeesListbyCompId(this.compId, this.empSize).subscribe((res) => {      
      if (res.isSucceeded) {
        this.subCompetencyChartData = res.value.items || [];
      }
    });

    this._service.getTrainingPercentage().subscribe((res) => {
      const comp = res.find((item) => item.competencyId === this.compId);
      if (comp && Object.keys(comp).length) {
        const chartObj = {
          'Completed': comp.completedPercentage,
          'Delayed': comp.delayedPercentage,
          'In progress': comp.inProgressPercentage,
          'New': comp.newPercentage,
        };

        this.trainingChartData.datasets = [{
          data: Object.values(chartObj) 
        }];
      }
    });

    this._service.getServiceAreaList().subscribe((data) => {
      this.serviceAreaList = data;
    });

    this._service.getCMFTrainingStatus().subscribe((res: any) => {
      if (res) {
        this.employeeTrainingStatus = res.filter((item) => item.competencyId === this.compId);
      }
    });
  }

  searchResult() {
    this.users = [];
    if (this.searchText == '') {
      this.totalItems = this.masterData.length;
      this.searchData = this.masterData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
      this.dataSource = new MatTableDataSource(this.searchData);
      return
    }
    const res = this.dataSource.data
    if (this.searchText) {
      this.users = this.masterData
      this.users = this.users
        .filter(obj => obj.trainingName.toLowerCase().includes(this.searchText.toLowerCase()))
        .map(obj => obj);
      this.totalItems = this.users.length;
    } else {
      this.totalItems = res.length;
    }

    if (this.users.length > 0) {
      this.totalItems = this.masterData.length;
      this.searchData = this.users.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
      this.dataSource = new MatTableDataSource(this.searchData)
    } else {
      this.toastr.error("No data found");
      this.dataSource = new MatTableDataSource(this.users)
    }

  }

  searchTrainings() {
    if (this.searchText) {
      const filteredData = this.totalTrainingData.filter(item =>
        item.sessionName.toLowerCase().includes(this.searchText.toLowerCase())
      );
      this.from = 0;
      this.dataSource = new MatTableDataSource(filteredData.slice(this.from, this.from ? this.from + this.size : 10));
      this.totalRecords = filteredData.length;
    } else {
      this.searchText = '';
      this.from = 0;
      this.dataSource = new MatTableDataSource(this.totalTrainingData.slice(this.from, this.from ? this.from + this.size : 10));
      this.totalRecords = this.totalTrainingData.length;
    }
  }

  getToolsFunctionSearch() {
    this.currentPage = 1;
    this.fetchData();
  }

  deleteTraining(trainingId: string) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "400px",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.data === "DELETE") {
        const params = {
          trainingId,
          competencyId: this.compId,
        };
        this._service.deleteCMFTraining(params).subscribe(() => {
          this.fetchData();
          this.renderTable();
          this.toastr.success("Training deleted Successfully");
        });
      }
    });
  }

  editFunction(id: number) {
    const sendData = {
      value: this.trainingTypeId,
      name: this.trainingTypeName,
    }
    this._service.getId(id);
    this._service.getSessionDetailsById().subscribe(
      (result) => {
        this.prepopulatedDataObject = result;
        this._service.setFormData(result);
        this._service.setCopyButtonStatus(false);
        this._service.setViewButtonStatus(false);
        this.subCompetencyName = this.subCompetencyName.replace(/\//g, '');
        this.subCompetencyName = this.subCompetencyName.split(' ').join('');
        this.router.navigate([`Home/Competencies/${this.competencyname}/${this.subCompetencyName}/Trainings/${sendData.name}/addTrainings`])
      }
    )


  }

  getStatusColor(status: string): string {
    if (status.includes('New')) {
      return '#ff9f40';
    } else if (status.includes('In Progress')) {
      return '#ff6e6e';
    } else if (status.includes('Completed')) {
      return '#7DBE7D';
    } else if (status.includes('Delayed')) {
      return '#ffce61';
    }
    return '#000';
  }

  copyFunction(id: number) {
    const sendData = {
      value: this.trainingTypeId,
      name: this.trainingTypeName,
    }
    this._service.getId(id);
    this._service.getSessionDetailsById().subscribe(
      (result) => {
        this.prepopulatedDataObject = result;
        this._service.setFormData(result);
        this._service.setCopyButtonStatus(true);
        this._service.setViewButtonStatus(false);
        this.subCompetencyName = this.subCompetencyName.replace(/\//g, '');
        this.subCompetencyName = this.subCompetencyName.split(' ').join('');
        this.router.navigate([`Home/Competencies/${this.competencyname}/${this.subCompetencyName}/Trainings/${sendData.name}/addTrainings`])
      }
    )
  }

  viewFunction(id: number) {
    const sendData = {
      value: this.trainingTypeId,
      name: this.trainingTypeName,
    }

    this._service.getId(id);
    this._service.getSessionDetailsById().subscribe(
      (result) => {
        this.prepopulatedDataObject = result;
        this._service.setFormData(result);
        this._service.setViewButtonStatus(true);
        this.subCompetencyName = this.subCompetencyName.replace(/\//g, '');
        this.subCompetencyName = this.subCompetencyName.split(' ').join('');
        this.router.navigate([`Home/Competencies/${this.competencyname}/${this.subCompetencyName}/Trainings/${sendData.name}/addTrainings`])
      }
    )
  }

  getToolGroups(tools) {
    let toolArray = tools.split(',');

    let groups = [];
    for (let i = 0; i < toolArray.length; i += 3) {
      groups.push(toolArray.slice(i, i + 3).join(','));
    }

    return groups;
  }

  getTrainerNameParts(name) {
    const parts = name.split(' ');

    if (parts.length > 2) {
      return parts;
    } else {
      return [name];
    }
  }
  onTabChange(event: MatTabChangeEvent): void {
    this.selectedTabIndex = event.index;
    this.from = 0;
    this.dataSource.data = this.totalTrainingData.slice(this.from, this.from ? this.from + this.size : 10);
    this.totalRecords = this.totalTrainingData.length;
  }

  handleTabSwitch() {
    this.selectedTabIndex = 1;
    this.matTab.focusTab(1);
    this.from = 0;
    this.renderTable();
  }

  getEmployeeList(training) {
    const employeeIds = training.resourcesPlanned.split(',').map(p => Number(p.trim()));
    const employees = this.subCompetencyChartData.filter(
      (item) => employeeIds.includes(item.employeeId)
    );
    employees.forEach((item) => {
      const employee = this.employeeTrainingStatus.find((emp) => emp.employeeId === item.employeeId);
      if (employee) {
        item.status = employee.trainingStatus;
      }
    });
    return employees;
  }

  openTrainingaction(training, readOnly) {
    const employees = this.getEmployeeList(training);
    const dialog = this.dialog.open(TrainingActionsComponent, {
      width: '1100px',
      height: '530px',
      data: {
        trainingDetails: { ...training, employees },
        readOnly,
      }
    });

    dialog.afterClosed().subscribe((res) => {
      if (res) {
        this.renderTable();
      }
    });
  }

  renderTable() {
    this._service.getTrainingData().subscribe((res) => {
      const compTitle = sessionStorage.getItem('compTitle');
      this.totalTrainingData = res
        .filter((item) => item.competency === compTitle)
        .map((item) => {
          return { ...item, ...this.getIconForStatus(item) };
        });
      this.totalRecords = this.totalTrainingData.length;
      this.dataSource.data = this.totalTrainingData.slice(this.from, this.from ? this.from + this.size : 10);
    });
  }

  getPaginatorData(event) {
    this.size = event.pageSize;
    this.from = event.pageIndex * this.size;
    this.renderTable();
  }

  exportEmployeesTraining(training) {
    const employees = this.getEmployeeList(training);
    let excelData = employees.map(i => {
      return {
        'Employee Id': i.employeeId,
        'First Name': i.firstName,
        'Last Name': i.lastName,
        'Email': i.email,
        "Status": i.status, 
      };
    });
    let fileName = 'CMF_' + training.sessionName;
    this.exportExcel(fileName, excelData);
  }

  exportExcel(fileName, excelData) {
    if (excelData.length) {
      this.excel.exportAsExcelFile(excelData, fileName);
    } else {
      this.toastr.error("No data available to export");
    }
  }

  exportTrainingData() {
    const excelData = this.totalTrainingData.map(i => {
      return {
        'Competency': i.competency,
        'Session Name': i.sessionName,
        'Start Date': i.startDate,
        'End Date': i.endDate,
        'Status': i.trainingStatusDescription,
      }
    });
    let fileName = 'CMF_Training_Details';
    this.exportExcel(fileName, excelData);
  }

  getIconForStatus(row) {
    const rowEndDate = new Date(row.endDate);
    const now = new Date();
    const rowEndDateOnlyDate = new Date(
      rowEndDate.getFullYear(),
      rowEndDate.getMonth(),
      rowEndDate.getDate()
    );
    const nowOnlyDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const threeDaysFromNow = new Date(nowOnlyDate);
    threeDaysFromNow.setDate(nowOnlyDate.getDate() + 3);
    const isApproaching = (nowOnlyDate <= rowEndDateOnlyDate) && (rowEndDateOnlyDate <= threeDaysFromNow);
    const isEndDatePassed = rowEndDate < now;
    const trainingSplit = row.trainingStatusDescription.split(', ');
    const completedStatus = trainingSplit.find(status => status.includes('Completed'));
    const completedCount = completedStatus.split(': ') && completedStatus.split(': ')[1]
      ? Number(completedStatus.split(': ')[1])
      : 0;
    if (isEndDatePassed) {
      return {
        icon: 'warning',
        color: 'red',
        tooltip: 'Training End Date has passed'
      };
    }
    if (isApproaching) {
      return {
        icon:'assignment_late',
        color: 'purple',
        tooltip: 'Training End Date is approaching'
      };
    }
    if (completedCount > 0) {
      return {
        icon: 'check_circle',
        color: 'green',
        tooltip: 'Training is on track'
      };
    } 
    if (completedCount === 0) {
      return {
        icon: 'schedule',
        color: '#cdd710',
        tooltip: 'Training is in progress'
      };
    }

    return '';
  }
}
